module.exports = __webpack_public_path__ + "img/vn_vn.d0c3f8f6.png";